module.exports={
  "title": "Choose a repair that works for you",
  "dsrepair": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "Doorstep Repair",
    "description": "Use our Doorstep Repair service where a Mobile Repair van will come to you on the day and repair your product on-site.<br /><br />You can book a date, time and location for your repair with our Authorised Service Partner. They will confirm your appointment and repair cost after receiving your booking request.<br /><br />Repairs are completed on the day<sup>1</sup> of the appointment.",
    "descriptionfold3flip3": "A mobile repair van comes to you to repair your product.<br /><br />You can book a date, time and location for your repair with our Authorised Service Partner. They will confirm your appointment and repair cost after receiving your booking request.<br /><br />Repairs are completed on the day<sup>1</sup> of the appointment.",
    "alt": "Van and home icon",
    "btncopy": "continue"
  },
  "psrepair": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "Pick up Repair",
    "description": "Our Authorised Service Partner will contact you to discuss the collection and drop-off options which are available in your area, and arrange the collection.<br/><br/>Once the device has been inspected, if the issue is found to be out of warranty terms, they will contact you with cost and timing for your repair. Once the repair is completed your device will be returned to you.",
    "alt": "Manual lifter trolley icon",
    "btncopy": "continue"
  },

  "psrepairtv": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "Pick up Repair",
    "description": "Our Authorised Service Partner will collect, repair, and return your product back to you.<br/><br/>Once your product has been inspected, if the issue is found to be out of warranty terms our Authorised Service Partner will contact you with the costs for repair.",
    "alt": "Pick up repair description",
    "btncopy": "continue"
  },
  "isrepair": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "In-store Repair",
    "description": "Book an appointment with a Samsung Expert at one of our Authorised Service Centres.<br/><br/>Book the date, time and location that works best for you.<br/><br/>Our Authorised Service Partner will confirm cost and timings for the repair at your appointment. <br /><br /><br />",
    "alt": "Two men and speach bouble icon",
    "btncopy": "continue"
  },
  "ihrepair": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "In-home Repair",
    "description": "A Samsung Authorised Expert will come to your home to inspect and repair your product.<br/><br/>Enter your details to book your appointment and our Authorised Service Partner will contact you to confirm cost and timings for your repair.<br /><br /><br />",
    "alt": "Man inside house icon",
    "btncopy": "continue"
  },
  "psihrepair": {
    "sectiontitle": "Book your repair",
    "title": "In-home or Pick up Repair",
    "description": "Enter your details to book your appointment and our Authorised Service Partner will contact you to confirm whether they will conduct a Pick Up or In-home Repair.<br/><br/>They will also be able to confirm cost if applicable and how long the repair may take.",
    "alt": "",
    "btncopy": "continue"
  },
  "ihrepairDATV": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "In-home Repair",
    "description": "A Samsung Authorised Expert will come to your home to inspect and repair your product.<br/><br/>To book, simply enter your product details and pick an appointment date which works best for you.<br /><br />Our Authorised Service Partner will contact you to confirm appointment timings and quote for any costs in relation to your repair. <br /><br /><br />",
    "alt": "Man inside house icon",
    "btncopy": "continue"
  },
  "psrepairDATV": {
    "sectiontitle": "Choose a repair that works for you",
    "title": "Pick up Repair",
    "description": "Our Authorised Service Partner will collect, repair, and return your product back to you.<br/><br/>To book, simply enter your product details and pick a collection date which works best for you.<br/><br/>Our Authorised Service Partner will contact you to confirm  collection timings and quote for any costs in relation to your repair.",
    "alt": "Man inside house icon",
    "btncopy": "continue"
  },
  "xxx": "copy end"
}
